import { Box, Typography } from '@mui/material';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import ManageAccountLayout from '@views/ManageAccount/ManageAccountLayout';
import Notifications from '@views/ManageAccount/Notifications/Notifications';

const messages = defineMessages({
  title: {
    id: 'manageAccount.notifications',
    defaultMessage: 'Notifications',
  },
  description: {
    id: 'manageAccount.notifications.description',
    defaultMessage:
      'Manage your notification preferences to ensure you receive the updates most relevant to you.',
  },
});

export default function ManageNotificationsPage(
  props: PagePropsWithBreadcrumbs
) {
  const { formatMessage } = useIntl();

  return (
    <ManageAccountLayout
      friendlyName={formatMessage(messages.title)}
      pageProps={props}
    >
      {({ user }) => (
        <Box>
          <Typography variant="caption">
            {formatMessage(messages.description)}
          </Typography>
          <Notifications user={user} />
        </Box>
      )}
    </ManageAccountLayout>
  );
}
